import React from 'react';
import { Container, Button } from 'react-bootstrap'; 
import img1 from '../images/8401.jpg' ; 

export default function Section2() {
  return ( 
      <section className="section2 " id="about">
        <div className="intro container-fluid col-12 d-flex row">
            <div className=" col-sm-12 col-md-5 col-lg-5 mx-auto ">
                <img src= {img1}  alt="illustration" />
            </div>
            <div className="col-sm-12 col-md-5 col-lg-5 text-right">
                <Container> 
                    <div className='text text-right'>
                        <h1>About Me</h1>
                         
                        <h6>To stand out in this online crowd, you need <br />an amazing design 
                        and a complete solution <br />where your business and idea will come to life. <br /> <br />
                        </h6>
                        <h6>If you need someone best in this UI/UX design Sector,<br /> my previous reputation and three years
                        <br />experience makes me one of them.<br /> <br />
                        </h6>
                        <h5>Let's bring your idea to life!</h5>
                    </div>
                    <div className='position-middle'>
                        <Button variant="outline-dark">
                            View Work
                        </Button>{' '} 
                        <Button variant="outline-dark">
                            Hire Me
                        </Button>
                    </div>     
                </Container>
            </div>
            
        </div> 
     </section> 
  )
}
